/* script for View Size Guide button */
$('body').on('click', '.view_sizechart_modal_btn', function() {
    $('#view-size_chart_modal').show();
    $("#view-size_chart_modal").addClass("zoomIn animated").fadeIn();
    $("#view-size_chart_modal").removeClass("zoomIn animated");
});

function sizechartModalHide() {
    $("#view-size_chart_modal").addClass("zoomOut animated").fadeOut();
    $("#view-size_chart_modal").removeClass("zoomOut animated");
}
window.onclick = function(event) {
    if (event.target.classList.contains('size_chart_overlay')) {
        $('#view-size_chart_modal .sizechart-modal-close').click();

    }

}



// window.onload=function(){
//     let hideDiv= document.getElementsByClassname('size_chart_overlay')
//     document.onclick=function(div){
//         if(div.target.classname !=='size_chart_overlay'){
//             hideDiv.style.display='none';
//         }
//     };
// };
$(document).mouseup(function(e) 
{
    var container = $(".size_chart_content");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $("#view-size_chart_modal").modal('hide');
    }
});
